import React from "react";
import ReactDOM from "react-dom";
import "./index.css"; // Import Tailwind CSS
import GospelitoPageV2 from "./components/GospelitoPageV2";

ReactDOM.render(
  <React.StrictMode>
    <GospelitoPageV2 />
  </React.StrictMode>,
  document.getElementById("root")
);
